<template>
    <v-card>
        <v-card-text v-if="schemaConfigHasThingSchemas">
            <schema-config-readout-group-list
                v-if="readoutGroups != null"
                :schemaConfig="schemaConfig"
                :readout-groups="readoutGroups"
                @saved="fetchData"
                @deleted="fetchData"
            />
            <schema-config-task-group-list
                v-if="taskGroups != null && readoutGroups != null"
                :schemaConfig="schemaConfig"
                :task-groups="taskGroups"
                :readout-groups="readoutGroups"
                @saved="fetchData"
                @deleted="fetchData"
            />
            <schema-config-task-template-list
                v-if="taskGroups != null && readoutGroups != null && schemaConfigTaskTemplates != null"
                :schemaConfig="schemaConfig"
                :task-groups="taskGroups"
                :readout-groups="readoutGroups"
                :schema-config-task-templates="schemaConfigTaskTemplates"
                @saved="fetchData"
                @deleted="fetchData"
            />
        </v-card-text>
        <v-card-text v-else>
            <v-card-title>Task Schedule Unavailable: {{schemaConfig.code}} has no Schemas</v-card-title>
        </v-card-text>
    </v-card>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { SchemaConfigAdminConfig } from "@/services/schemas/manageSchemasAPI";
import { readoutGroupsAPI, SavedReadoutGroup } from "@/services/readoutGroups/readoutGroupsAPI";
import { SavedTaskGroup, taskGroupsAPI } from "@/services/taskGroups/taskGroupsAPI";
import { withLoadingScreen } from "@/lib/loading";
import SchemaConfigReadoutGroupList from "@/components/SchemaConfig/SchemaConfigReadoutGroupList.vue";
import SchemaConfigTaskGroupList from "@/components/SchemaConfig/SchemaConfigTaskGroupList.vue";
import SchemaConfigTaskTemplateList from "@/components/SchemaConfig/SchemaConfigTaskTemplateList.vue";
import { SavedSchemaConfigTaskTemplate, taskTemplatesAPI } from "@/services/taskTemplates/taskTemplatesAPI";
import { onMounted } from "vue";

const { schemaConfig } = defineProps<{
    schemaConfig: SchemaConfigAdminConfig
}>();

const readoutGroups = ref<SavedReadoutGroup[] | null>();
const taskGroups = ref<SavedTaskGroup[] | null>();
const schemaConfigTaskTemplates = ref<SavedSchemaConfigTaskTemplate[] | null>();

onMounted(() => {
    fetchData();
});

const schemaConfigHasThingSchemas = computed(() => {
    return schemaConfig.thingSchemas.length > 0;
});

async function fetchData() {
    await withLoadingScreen(async () => {
        const schemaConfigId = schemaConfig.id;
        readoutGroups.value = await readoutGroupsAPI.bySchemaConfig(schemaConfigId).fetchAll();
        taskGroups.value = await taskGroupsAPI.bySchemaConfig(schemaConfigId).fetchAll();
        schemaConfigTaskTemplates.value = await taskTemplatesAPI.bySchemaConfig(schemaConfigId).fetchAll();
    });
}

</script>
